<template>
    <v-col cols="12">
        <v-row>
            <v-col cols="5">
                <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    persistent
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="dateRangeText"
                        label="Date Range"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                    ></v-text-field>
                    </template>
                    <v-row style="background:white">
                        <v-col :cols="rangeDateData">
                            <v-radio-group
                            :mandatory="false"
                            class="large"
                            column
                            v-model="dateData"
                            style="margin-left:5px;">
                                <v-radio label="Today" value="today"></v-radio>
                                <v-radio label="Yesterday" value="yesterday"></v-radio>
                                <v-radio label="Last 7 days" value="last7days"></v-radio>
                                <v-radio label="Last 30 days" value="last30days"></v-radio>
                                <v-radio label="Custom" value="custom"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col :cols="rangeCalender" v-if="dateData == 'custom'">
                            <v-date-picker
                            v-model="dates"
                            range
                            scrollable
                            v-if="menu2"
                            ></v-date-picker>
                        </v-col>
                    </v-row>
                    <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
                </v-menu>
            </v-col>

            <v-col cols="5">
                <v-select
                :items="listSites"
                label="Store"
                v-model="siteSelected"
                :item-text="(obj) => obj.code"
                :item-value="(obj) => obj.code"
                multiple
                outlined dense></v-select>
            </v-col>


            <v-col cols="2">
                <v-btn @click="loadData" v-if="dates.length > 0 && siteSelected.length > 0">Show Report</v-btn>
                <v-btn v-else disabled>Show Report</v-btn>
            </v-col>

        </v-row>
    
        <div v-if="loading == true">
        <img v-bind:src="require('../../../assets/loading/loading.gif')" />
        </div>
        <div v-else>
            <v-simple-table fixed-header height="95vh">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="cell-border" colspan="3">
                                <v-row>
                                    <v-col cols="6">
                                        <v-select
                                        :items="listChannels"
                                        label="Marketing Channel"
                                        dense
                                        v-model="channelSelected"
                                        ></v-select>
                                    </v-col>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-col cols="5.7">
                                        <v-text-field label="Search..." dense v-model="search"></v-text-field>                                
                                    </v-col>
                                </v-row>
                            </th>
                            <th class="cell-border">{{ sumData.sumCampSpent.toFixed(2) }}</th>
                            <th class="cell-border">{{ sumData.sumOrders.toFixed(2) }}</th>
                            <th class="cell-border">{{ sumData.sumSales.toFixed(2) }}</th>
                            <th class="cell-border">{{ sumData.sumRevenue.toFixed(2) }}</th>
                            <th class="cell-border">{{ sumData.sumTempProfit.toFixed(2) }}</th>
                            <th class="cell-border">{{ sumData.sumTempNetProfit.toFixed(2) }}</th>
                            <th class="cell-border" colspan="7">{{ reportData.length }} item(s)</th>
                        </tr>
                        <tr>
                            <th class="cell-border">UTM Campaign Source</th>
                            <th class="cell-border"><div class="resize-div">UTM Term</div></th>

                            <th class="cell-border"><div class="resize-div">UTM Campaign Name</div></th>


                            <th class="cell-border" @click="sortData('campaign_spent')">
                                Campaign Spent
                                <v-icon x-small v-if="sortBy == 'campaign_spent' && !sortType">mdi-arrow-up</v-icon>
                                <v-icon x-small v-else-if="sortBy == 'campaign_spent' && sortType">mdi-arrow-down</v-icon>
                                <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
                            </th>

                            <th class="cell-border" @click="sortData('total_orders')">
                                Total Orders
                                <v-icon x-small v-if="sortBy == 'total_orders' && !sortType">mdi-arrow-up</v-icon>
                                <v-icon x-small v-else-if="sortBy == 'total_orders' && sortType">mdi-arrow-down</v-icon>
                                <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
                            </th>

                            <th class="cell-border" @click="sortData('total_sales')">
                                Total Sales
                                <v-icon x-small v-if="sortBy == 'total_sales' && !sortType">mdi-arrow-up</v-icon>
                                <v-icon x-small v-else-if="sortBy == 'total_sales' && sortType">mdi-arrow-down</v-icon>
                                <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
                            </th>

                            <th class="cell-border" @click="sortData('revenue')">
                                Revenue
                                <v-icon x-small v-if="sortBy == 'revenue' && !sortType">mdi-arrow-up</v-icon>
                                <v-icon x-small v-else-if="sortBy == 'revenue' && sortType">mdi-arrow-down</v-icon>
                                <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
                            </th>

                            <th class="cell-border" @click="sortData('temp_profit')">
                                Temp Profit
                                <v-icon x-small v-if="sortBy == 'temp_profit' && !sortType">mdi-arrow-up</v-icon>
                                <v-icon x-small v-else-if="sortBy == 'temp_profit' && sortType">mdi-arrow-down</v-icon>
                                <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
                            </th>

                            <th class="cell-border" @click="sortData('temp_net_profit')">
                                Temp Net Profit
                                <v-icon x-small v-if="sortBy == 'temp_net_profit' && !sortType">mdi-arrow-up</v-icon>
                                <v-icon x-small v-else-if="sortBy == 'temp_net_profit' && sortType">mdi-arrow-down</v-icon>
                                <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
                            </th>

                            <th class="cell-border" @click="sortData('ROAS')">
                                ROAS
                                <v-icon x-small v-if="sortBy == 'ROAS' && !sortType">mdi-arrow-up</v-icon>
                                <v-icon x-small v-else-if="sortBy == 'ROAS' && sortType">mdi-arrow-down</v-icon>
                                <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
                            </th>

                            <th class="cell-border"><div class="resize-div">UTM Medium</div></th>
                            <th class="cell-border">Ad set Spent</th>
                            <th class="cell-border">Orders</th>
                            <th class="cell-border">Sales</th>
                            <th class="cell-border"><div class="resize-div">Title</div></th>
                            <th class="cell-border">Product Code</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(i,indexi) of reportData">
                            <template v-if="i.utm_mediums.length > 0">
                                <template v-for="(j,indexj) in i.utm_mediums">
                                    <template v-if="j.products.length == 0">
                                        <tr :key="indexi+'-'+indexj">
                                                <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.utm_campaign_source }}</td>
                                                <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.utm_term }}</td>
                                                <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.utm_campaign_name }}</td>
                                                <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.campaign_spent }}</td>
                                                <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.total_orders }}</td>
                                                <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.total_sales }}</td>
                                                <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.revenue }}</td>
                                                <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.temp_profit }}</td>
                                                <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.temp_net_profit }}</td>
                                                <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.ROAS }}</td>
                                                
                                                <td class="cell-border cell-color" v-if="indexj == 0" :rowspan="j.count_utm_prods">{{j.utm_medium}}</td>
                                                <td class="cell-border cell-color" v-else :rowspan="j.count_utm_prods">{{j.utm_medium}}</td>

                                                <td class="cell-border cell-color" v-if="indexj == 0" :rowspan="j.count_utm_prods">{{j.adset_spent}}</td>
                                                <td class="cell-border cell-color" v-else :rowspan="j.count_utm_prods">{{j.adset_spent}}</td>

                                                <td class="cell-border cell-color" v-if="indexj == 0" :rowspan="j.count_utm_prods">{{j.orders}}</td>
                                                <td class="cell-border cell-color" v-else :rowspan="j.count_utm_prods">{{j.orders}}</td>
                                                
                                                <td class="cell-border cell-color"></td>
                                                <td class="cell-border cell-color"></td>
                                                <td class="cell-border cell-color"></td>
                                            </tr>
                                    </template>

                                    <template v-else>
                                        <template v-for="(valuek,indexk) in j.products">
                                            <template v-if="indexk == 0">
                                                <tr :key="indexi+'-'+indexj+'-'+indexk">
                                                    <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.utm_campaign_source }}</td>
                                                    <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.utm_term }}</td>
                                                    <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.utm_campaign_name }}</td>
                                                    <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.campaign_spent }}</td>
                                                    <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.total_orders }}</td>
                                                    <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.total_sales }}</td>
                                                    <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.revenue }}</td>
                                                    <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.temp_profit }}</td>
                                                    <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.temp_net_profit }}</td>
                                                    <td class="cell-border" v-if="indexj == 0" :rowspan="i.count">{{ i.ROAS }}</td>
                                                    
                                                    <td class="cell-border cell-color" v-if="indexj == 0" :rowspan="j.count_utm_prods">{{j.utm_medium}}</td>
                                                    <td class="cell-border cell-color" v-else :rowspan="j.count_utm_prods">{{j.utm_medium}}</td>

                                                    <td class="cell-border cell-color" v-if="indexj == 0" :rowspan="j.count_utm_prods">{{j.adset_spent}}</td>
                                                    <td class="cell-border cell-color" v-else :rowspan="j.count_utm_prods">{{j.adset_spent}}</td>

                                                    <td class="cell-border cell-color" v-if="indexj == 0" :rowspan="j.count_utm_prods">{{j.orders}}</td>
                                                    <td class="cell-border cell-color" v-else :rowspan="j.count_utm_prods">{{j.orders}}</td>
                                                    
                                                    <td class="cell-border cell-color" v-if="indexk == 0">{{ valuek.sales }}</td>

                                                    <td class="cell-border cell-color" v-if="indexk == 0">{{ valuek.product_title }}</td>

                                                    <td class="cell-border cell-color" v-if="indexk == 0">{{ valuek.product_code }}</td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr :key="indexi+'-'+indexj+'-'+indexk">
                                                    <td class="cell-border cell-color" >{{ valuek.sales }}</td>
                                                    <td class="cell-border cell-color" >{{ valuek.product_title }}</td>
                                                    <td class="cell-border cell-color">{{ valuek.product_code }}</td>
                                                </tr>
                                            </template>
                                        </template>
                                    </template>                                    
                                </template>
                            </template>
                            <template v-else>
                                <tr :key="indexi">
                                    <td class="cell-border">{{ i.utm_campaign_source }}</td>
                                    <td class="cell-border">{{ i.utm_term }}</td>
                                    <td class="cell-border">{{ i.utm_campaign_name }}</td>
                                    <td class="cell-border">{{ i.campaign_spent }}</td>
                                    <td class="cell-border">{{ i.total_orders }}</td>
                                    <td class="cell-border">{{ i.total_sales }}</td>
                                    <td class="cell-border">{{ i.revenue }}</td>
                                    <td class="cell-border">{{ i.temp_profit }}</td>
                                    <td class="cell-border">{{ i.temp_net_profit }}</td>
                                    <td class="cell-border">{{ i.ROAS }}</td>  
                                    <td class="cell-border"></td>
                                    <td class="cell-border"></td>
                                    <td class="cell-border"></td>
                                    <td class="cell-border"></td>
                                    <td class="cell-border"></td>
                                    <td class="cell-border"></td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
       
    </v-col>
</template>

<script>
    import axios from "axios";
    import moment from "moment-timezone"

    export default {
        name:"MarketingReportComponent",
        
        data:() => ({
            loading:false,
            search:"",
            menu2: false,
            dateData:'',
            rangeCalender:0,
            rangeDateData:12,
            dates:[],

            originalData:[],
            reportData:[],
            
            sortBy:'',
            sortType:'',

            listChannels:['All','facebook','google','tiktok','klaviyo'],
            channelSelected:'',

            listSites:[],
            siteSelected:[],

            sumData:{
                sumCampSpent:0,
                sumOrders:0,
                sumSales:0,
                sumRevenue:0,
                sumTempProfit:0,
                sumTempNetProfit:0
            }
        }),
        computed: {
            dateRangeText() {
                if(this.dateData == 'custom'){
                    return this.dates.join(" ~ ");
                }else {
                    let a  = ''
                    if(this.dateData == 'today'){
                        a = 'Today'
                    }
                    else if(this.dateData == 'yesterday'){
                        a =  'Yesterday'
                    }
                    else if(this.dateData == 'last7days'){
                        a = 'Last 7 days'
                    }
                    else if(this.dateData == 'last30days'){
                        a = 'Last 30 days'
                    }
                    return a;
                }
            },
        },
        watch:{
            dateData(){
                this.dates=[]
                if(this.dateData == 'custom'){
                    this.rangeCalender = 8
                    this.rangeDateData = 4
                }else{
                    this.rangeCalender = 0
                    this.rangeDateData = 12
                    this.dateCalculate(this.dateData)
                }
            },
            search() {
                this.searchData();
            },
            channelSelected(){
                this.searchData();
            }
        },

        methods:{
            dateCalculate(data){
                let startDate = null;
                let endDate = null
                if(data == 'today'){
                    startDate = moment(new Date()).format("YYYY-MM-DD");
                    endDate = moment(new Date()).format("YYYY-MM-DD");
                    this.dates.push(startDate)
                    this.dates.push(endDate)
                }else if(data == 'yesterday'){
                    startDate = moment(new Date()).subtract(1, 'days').format("YYYY-MM-DD");
                    endDate = moment(new Date()).subtract(1, 'days').format("YYYY-MM-DD");
                    this.dates.push(startDate)
                    this.dates.push(endDate)
                }else if(data == 'last7days'){
                    startDate = moment(new Date()).subtract(7, 'days').format("YYYY-MM-DD");
                    endDate = moment(new Date()).format("YYYY-MM-DD");
                    this.dates.push(startDate)
                    this.dates.push(endDate)
                }else if(data == 'last30days'){
                    startDate = moment(new Date()).subtract(30, 'days').format("YYYY-MM-DD");
                    endDate = moment(new Date()).format("YYYY-MM-DD");
                    this.dates.push(startDate)
                    this.dates.push(endDate)
                }
            },

            async loadSites() {
                var currentSession = await this.$root.$refs.App.currentSession(
                    "sites-loadData"
                );
                if (currentSession.accessToken) {
                    axios
                    .get(window.domain + "sites", {
                        headers: { Authorization: currentSession.accessToken },
                    })
                    .then((response) =>{
                        this.listSites = response.data.data
                    })
                    .catch((error) => {
                        console.log("error ", error);
                    });
                }
            },

            async loadData() {
                this.loading = true;
                this.reportData = [];
                this.search = '';
                this.channelSelected = '';
                var currentSession = await this.$root.$refs.App.currentSession(
                    "marketing-report-loadData"
                );
                if (currentSession.accessToken) {
                    let queryParams = {
                        report_type: 'marketing_campaigns',
                        store_codes: this.siteSelected.join(","),
                        report_range: this.dateData,
                    }

                    if (this.dates.length > 0) {
                        if (this.dates[0] > this.dates[1]) {
                        queryParams["report_from"] = this.dates[1];
                        queryParams["report_to"] = this.dates[0];
                        } else {
                        queryParams["report_from"] = this.dates[0];
                        queryParams["report_to"] = this.dates[1];
                        }
                    }

                    await axios
                    .get(window.domain + "reports/profit", {
                        headers: { Authorization: currentSession.accessToken },
                        params: queryParams,
                    })
                    .then((response) => {
                        // If request is good...
                        console.log("response: ", response);
                        this.reportData = response.data.data;
                        for(let t of this.reportData){
                            let count = 0
                            if(t.utm_mediums.length > 0){
                                for(let i of t.utm_mediums){
                                    i["count_utm_prods"] = i.products.length == 0? 1:i.products.length
                                    count += i["count_utm_prods"]
                                    //count += i.products.length == 0? 1:i.products.length
                                }
                            }else{
                                count = 1
                            }
                            t['count'] = count

                            if(t.campaign_spent != 0)
                            {
                                t['ROAS'] = parseFloat(t.revenue/t.campaign_spent).toFixed(2)
                            }
                            else{
                                t['ROAS'] = ""
                            }
                        }

                        this.originalData = Object.assign(this.originalData,response.data.data)
                        console.log("reportData: ", this.reportData);
                        this.sumCalculator()
                    })
                    .catch((error) => {
                        console.log("error ", error);
                    });
                } else {
                    console.log("currentSession user-loadData-undefined: ", currentSession);
                }
                this.loading = false;
            },

            sortData(col) {
                this.sortBy = col;
                if (this.sortType == null) {
                    this.sortType = false;
                } else {
                    this.sortType = !this.sortType;
                }

                if (this.sortType == false)
                    this.reportData.sort((a, b) => (a[col] > b[col] ? 1 : -1));
                else this.reportData.sort((a, b) => (a[col] < b[col] ? 1 : -1));
            },

            searchData(){
                this.reportData = []

                if(this.channelSelected != 'All' && this.channelSelected != ''){
                    if(this.search != ''){
                         let temp = this.originalData.filter(t => t.utm_campaign_source == this.channelSelected)
                         
                         this.reportData = temp.filter( t => t.utm_term.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                            t.utm_campaign_name.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                        
                    }else{
                        this.reportData = this.originalData.filter(t =>t.utm_campaign_source == this.channelSelected)
                    }
                }else{
                    if(this.search != ''){
                        this.reportData = this.originalData.filter(t =>
                            t.utm_term.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                            t.utm_campaign_name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                        )
                    }else{
                        this.reportData = Object.assign(this.reportData,this.originalData)
                    }
                }

                //console.log("search: ",this.search," - this.reportData: ",this.reportData)
                this.sumCalculator()
            },

            sumCalculator(){
                this.sumData = {
                    sumCampSpent:0,
                    sumOrders:0,
                    sumSales:0,
                    sumRevenue:0,
                    sumTempProfit:0,
                    sumTempNetProfit:0
                }

                this.reportData.map(t => {
                    this.sumData.sumCampSpent += t.campaign_spent
                    this.sumData.sumOrders += t.total_orders
                    this.sumData.sumSales += t.total_sales
                    this.sumData.sumRevenue += t.revenue
                    this.sumData.sumTempProfit += t.temp_profit
                    this.sumData.sumTempNetProfit += t.temp_net_profit
                })
                //console.log('this.sumData: ',this.sumData)
            }
        },

        async mounted(){
            await this.loadSites()
        }
    }
</script>

<style lang="scss" scoped>
.cell-border{
    border: thin solid rgba(0, 0, 0, 0.12);
}

.cell-color{
    background-color: #D9EAD3;
}

.resize-div{
    resize: both;
  overflow: auto;
  display: block;
}

</style>